/* tslint:disable */
/* eslint-disable */
/**
 * Commerce Webservices
 * Manages all of the common commerce functionality, and also includes customizations from installed AddOns. The implementing extension is called commercewebservices.
 *
 * The version of the OpenAPI document: 2.2.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * Representation of a metadata of an Order Subsequent Document Entry
 * @export
 * @interface SAPOrderSubsequentDocumentEntry
 */
export interface SAPOrderSubsequentDocumentEntry {
    /**
     * Subsequent Document Entry Number
     * @type {string}
     * @memberof SAPOrderSubsequentDocumentEntry
     */
    sapSubsequentDocumentEntryNumber?: string;
    /**
     * Order Entry Number
     * @type {string}
     * @memberof SAPOrderSubsequentDocumentEntry
     */
    sapOrderEntryNumber?: string;
    /**
     * Creation Date/Time
     * @type {string}
     * @memberof SAPOrderSubsequentDocumentEntry
     */
    sapCreatedAt?: string;
    /**
     * Name of the Status of the Document
     * @type {string}
     * @memberof SAPOrderSubsequentDocumentEntry
     */
    sapStatus?: string;
}

/**
 * Check if a given object implements the SAPOrderSubsequentDocumentEntry interface.
 */
export function instanceOfSAPOrderSubsequentDocumentEntry(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function SAPOrderSubsequentDocumentEntryFromJSON(json: any): SAPOrderSubsequentDocumentEntry {
    return SAPOrderSubsequentDocumentEntryFromJSONTyped(json, false);
}

export function SAPOrderSubsequentDocumentEntryFromJSONTyped(json: any, ignoreDiscriminator: boolean): SAPOrderSubsequentDocumentEntry {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'sapSubsequentDocumentEntryNumber': !exists(json, 'sapSubsequentDocumentEntryNumber') ? undefined : json['sapSubsequentDocumentEntryNumber'],
        'sapOrderEntryNumber': !exists(json, 'sapOrderEntryNumber') ? undefined : json['sapOrderEntryNumber'],
        'sapCreatedAt': !exists(json, 'sapCreatedAt') ? undefined : json['sapCreatedAt'],
        'sapStatus': !exists(json, 'sapStatus') ? undefined : json['sapStatus'],
    };
}

export function SAPOrderSubsequentDocumentEntryToJSON(value?: SAPOrderSubsequentDocumentEntry | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'sapSubsequentDocumentEntryNumber': value.sapSubsequentDocumentEntryNumber,
        'sapOrderEntryNumber': value.sapOrderEntryNumber,
        'sapCreatedAt': value.sapCreatedAt,
        'sapStatus': value.sapStatus,
    };
}

